import React from "react";

const WhatsAppFloat = () => {
  return (
    <a
      href="https://wa.me/919825076797"
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-float"
      title="Chat on WhatsApp"
    >
      <svg viewBox="0 0 32 32" fill="currentColor">
        <path d="M16 0C7.164 0 0 7.164 0 16c0 2.825.738 5.487 2.031 7.794L0 32l8.394-2.019A15.923 15.923 0 0016 32c8.836 0 16-7.164 16-16S24.836 0 16 0zm7.294 22.377c-.4.2-.875.1-.875.1s-2.369-1.169-2.738-1.3c-.369-.131-.637-.2-.906.2-.269.4-1.038 1.3-1.275 1.569-.238.269-.475.3-.875.1-.4-.2-1.688-.623-3.213-1.988-1.188-1.062-1.988-2.375-2.219-2.775-.231-.4-.025-.619.175-.819.181-.181.4-.475.6-.712.2-.238.269-.4.4-.669.131-.269.069-.5-.031-.7-.1-.2-.906-2.181-1.244-2.988-.331-.788-.662-.681-.906-.694-.237-.012-.506-.012-.775-.012s-.712.1-1.081.5c-.369.4-1.413 1.381-1.413 3.369s1.444 3.906 1.644 4.175c.2.269 2.825 4.313 6.844 6.05.956.413 1.7.656 2.281.844.962.306 1.838.262 2.531.162.769-.112 2.369-.969 2.7-1.906.331-.937.331-1.738.231-1.906-.1-.169-.369-.269-.769-.469z" />
      </svg>
    </a>
  );
};

export default WhatsAppFloat;
